export const documents = {
  "documents.create": "documents.create",
  "documents.edit": "documents.edit",
  "documents.setStatus": "documents.setStatus",
  "documents.get": "documents.get",
  "documents.createSection": "documents.createSection",
  "documents.editSection": "documents.editSection",
  "documents.deleteSection": "documents.deleteSection",
  "documents.getSection": "documents.getSection",
  "documents.getFolder": "documents.getFolder",
} as const;
